export const pageVariants = {
    in:{
        opacity: 1,
        x: 0
    },
    out:{
        opacity: 0,
        x: "-100vh"
    }
}

export const pageTransition = {
    type: "spring",
    stiffness:50
}